import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    dialogContent: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        minWidth: '700px',
        maxWidth: '700px',
        '@media (max-width: 767px)': {
            minWidth: 'auto',
            width: '100%',
        },
    },
    dialogPaper: {
        minWidth: '700px',
        '@media (max-width: 767px)': {
            minWidth: 'calc(100% - 32px)',
        },
    },
    box: {
        display: 'flex',
        flexFlow: 'column',
        height: '100%',
    },
    header: {
        flex: '0 1 auto',
        display: 'flex',
        padding: '15px 10px',
        alignItems: 'baseline',
        cursor: 'move',
        backgroundColor: '#454545',
        justifyContent: 'space-between',
    },
    title: {
        fontFamily: 'Lato',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    content: {
        marginBottom: '10px',
        padding: '10px 20px',
    },
    errorText: {
        color: 'red',
    },
    formFieldColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        '& > .MuiAutocomplete-root': {
            width: '100%',
            margin: '5px 0px',
        },
    },
    unassignConfirmation: {
        marginBottom: '18px',
    },
    unassignMessage: {
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 600,
        color: '#303030',
        marginBottom: '7px',
    },
    unassignImei: {
        fontSize: '14px',
        lineHeight: '20px',
        color: '#52575C',
        '& span': {
            fontWeight: 600,
            color: '#303030',
        },
    },
    unassignReasonLabel: {
        fontSize: '15px',
        lineHeight: '20px',
        fontWeight: 600,
        color: '#303030',
        marginBottom: '5px',
        '& span': {
            color: '#e53935',
        },
    },
    cartonSelect: {
        width: '100%',
        height: '35.63px',
        margin: 0,
        boxSizing: 'border-box',
        '& .MuiOutlinedInput-root': {
            height: '35.63px',
            minHeight: '35.63px',
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: '4px',
            boxSizing: 'border-box',
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 4px',
            fontSize: '14px',
        },
    },
    footer: {
        flex: '0 1 40px',
        padding: '15px 20px',
        background: '#F8F9FB',
    },
    footerRight: {
        float: 'right',
        marginRight: '-8px',
        display: 'flex',
        gap: '10px',
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#0049A3',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #0049A3',
    },
    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        },
    },
}));
